import { createContext } from "react";
import { contextAsyncFunctionInit, contextFunctionInit } from "sprint-common-web";

import { defaultOnPremOrderListingConfig, OnPremOrderListingConfig } from "../config/OnPremOrderListingConfig";
import { OnPremOrderListingFilters } from "../hooks/useOnPremOrderListingFilters";
import { OnPremOrderListingItem } from "../OnPremOrderListingItem";

interface IOnPremOrderListingContext {
    items: OnPremOrderListingItem[];
    selectedItems: OnPremOrderListingItem[];
    pinnedItems: string[];
    totalItems: number;
    listingConfig: OnPremOrderListingConfig;
    saveListingConfig(config: OnPremOrderListingConfig): void;
    setSelectedItems(selectedItems: OnPremOrderListingItem[]): void;
    reloadData(filters: OnPremOrderListingFilters): Promise<void>;
    updateOnPremOrder(
        onPremOrder: Partial<OnPremOrderListingItem> & Required<Pick<OnPremOrderListingItem, "id">>
    ): void;
    togglePinnedOnPremOrder(orderId: string): void;
}

export const OnPremOrderListingContext = createContext<IOnPremOrderListingContext>({
    items: [],
    selectedItems: [],
    pinnedItems: [],
    totalItems: 0,
    listingConfig: defaultOnPremOrderListingConfig(),
    saveListingConfig: contextFunctionInit,
    setSelectedItems: contextFunctionInit,
    reloadData: contextAsyncFunctionInit,
    updateOnPremOrder: contextAsyncFunctionInit,
    togglePinnedOnPremOrder: contextAsyncFunctionInit
});
